import { Grid } from '@material-ui/core'
import React, { useContext, useEffect } from 'react'
import { ConfigurationContext } from '../../../context api/Configuration/ConfigurationContext'
import { useRegion } from '../../../hooks/CompanyConfiguration/useRegion'
import { useLocation } from '../../../hooks/Location/useLocation'
import { sortByName } from '../../../shared/constants'
import CustomInput from '../../CustomInput'
import CustomSelect from '../../CustomSelect'
import SwitchStatus from '../../SwitchStatus'

function DistrictFormComp({ state, setState, edit }) {
  const { name, region, zone, state1, districtCode, active } = state
  const { getAllRegion } = useRegion()
  // const { getAllZone } = useZone()
  // const { getAllStates } = useStates()
  const { regions } = useContext(ConfigurationContext)

  const { zones, getAllZone, getAllState, states, getAllDistrict } = useLocation()

  useEffect(() => {
    getAllRegion()
  }, [])

  useEffect(() => {
    if (region) {
      getAllZone({ region: region })
    }
    if (zone) {
      getAllState({ region: region, zone: zone })
    }
    if (state1) {
      getAllDistrict({ region: region, zone: zone, state: state1 })
    }
  }, [region, zone, state1])

  const data = [
    { label: 'District Code', value: districtCode, name: 'districtCode' },
    { label: 'Name', value: name, name: 'name' },
    { label: 'Region', value: region, name: 'region', select: true, options: sortByName(regions) },
    { label: 'Zone', value: zone, name: 'zone', select: true, options: sortByName(zones) },
    { label: 'State', value: state1, name: 'state1', select: true, options: sortByName(states) },
  ]
  return (
    <Grid container>
      {data.map((item, index) =>
        item.select ? (
          <Grid item lg={4}>
            <CustomSelect
              label={item.label}
              button={item.button}
              options={item.options}
              value={item.value}
              // handleChange={item.handleChange}
              form={state}
              setForm={setState}
              formCheck={true}
              name={item.name}
              disabled={item.disabled}
            />
          </Grid>
        ) : (
          <Grid item lg={4}>
            <CustomInput
              label={item.label}
              icon={item.icon}
              name={item.name}
              value={item.value}
              number={item.number ? true : false}
              //   form={targetForm}
              //   setForm={setTargetForm}
              form={state}
              setForm={setState}
              formCheck={true}
              type={item.type}
            />
          </Grid>
        )
      )}
      {edit && <SwitchStatus form={state} setForm={setState} value={active} />}
    </Grid>
  )
}

export default DistrictFormComp
